function SimpleSponsorCard(sponsor) {
    return (
        <div className="relative flex justify-center items-center mt-10 border-2 border-none rounded-lg shadow-sm hover:shadow-2xl">
            <a 
                href={sponsor.link} 
                target="_blank" 
                rel="noreferrer" 
                className="relative flex justify-center items-center w-[350px] h-[250px] overflow-hidden"
            >
                <img 
                    src={sponsor.logo} 
                    className="w-full h-full object-contain"  
                    alt={sponsor.name} 
                />
            </a>       
        </div>
    );
}

export default SimpleSponsorCard;
